import React, { FC, useCallback, useEffect, useState } from "react";
import {
  ContentWrapper,
  Heading,
} from "containers/RightPanel/RightPanel.styles";
import { ButtonColor, ButtonType, ButtonVariant } from "enums/Button";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  ButtonsWrapper,
  Content,
  FormWrapper,
} from "../../../../components/Addresses/components/AddressForm.styles";
import Button from "../../../../components/Button/Button";
import Input from "../../../../components/Input/Input";
import { createShopifyItem } from "../../../../reduxFolder/reducers/shopifyItems";
import { closeRightPanel } from "../../../../reduxFolder/reducers/rightPanel";
import { toastResponseError } from "../../../../utils/responseMessageHelper";

interface ShopifyItemFormPanelProps {
  panelData: any;
  isOpen: boolean;
  closeRightPanel: () => void;
  createShopifyItem: (profileId: number, data: any) => Promise<any>;
}

const ShopifyItemFormPanel: FC<ShopifyItemFormPanelProps> = ({
  panelData,
  isOpen,
  closeRightPanel,
  createShopifyItem,
}) => {
  const { t } = useTranslation("common");
  const profileId = panelData.get("profileId");
  const [itemId, setItemId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!isOpen) setItemId("");
  }, [isOpen]);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (!itemId.trim()) return;
      setIsSubmitting(true);
      createShopifyItem(profileId, { item_id: parseInt(itemId, 10) })
        .then(() => closeRightPanel())
        .catch(toastResponseError)
        .finally(() => setIsSubmitting(false));
    },
    [itemId, profileId, createShopifyItem, closeRightPanel],
  );

  return (
    <ContentWrapper>
      <Heading>{t("shopify.addItem")}</Heading>
      <FormWrapper onSubmit={handleSubmit}>
        <Content>
          <Input
            placeholder={t("shopify.itemId")}
            name="item_id"
            value={itemId}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setItemId(e.target.value)
            }
          />
        </Content>
        <ButtonsWrapper>
          <Button onClick={closeRightPanel}>{t("common.cancel")}</Button>
          <Button
            isLoading={isSubmitting}
            disabled={isSubmitting || !itemId.trim()}
            type={ButtonType.Submit}
            color={ButtonColor.Primary}
            variant={ButtonVariant.Filled}
          >
            {t("shopify.addItem")}
          </Button>
        </ButtonsWrapper>
      </FormWrapper>
    </ContentWrapper>
  );
};

const withConnect = connect(null, {
  createShopifyItem,
  closeRightPanel,
});

export default withConnect(ShopifyItemFormPanel);
